/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.0-v202611042218-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqExportApiClass {
 
   constructor() {}

  /**
   * @summary Archive an export
   * @param {string} id - ID of the export to archive
  */
  public archiveExport(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/export/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/export/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ExportItemsOutputV1>;
  }

  /**
   * @summary Archive any exports that have not been updated or used in the timeframe provided. This may only be performed by administrators.
   * @param {string} duration=90 days - Archive any exports older than &#x27;duration&#x27;
  */
  public archiveExportsOlderThan(
    {
      duration
    } : {
      duration: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (duration === null || duration === undefined) {
      throw new Error("'duration' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/export/cleanup`;
    const urlTemplate = `${baseUrl}/export/cleanup`;

    const queryParams = {
      ['duration']: duration
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Export data in the specified output format. Currently only xlsx and odata are supported.
  */
  public createExport(
    body: models.ExportItemsV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/export`;
    const urlTemplate = `${baseUrl}/export`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<Blob>;
  }

  /**
   * @summary Get the details of an export
   * @param {string} id - ID of the export to retrieve
  */
  public getExport(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/export/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/export/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ExportItemsOutputV1>;
  }

  /**
   * @summary Get a collection of exports
   * @param {boolean} [includeArchived=false] - Whether archived exports should be included
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getExports(
    {
      includeArchived,
      offset,
      limit
    } : {
      includeArchived?: boolean,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/export`;
    const urlTemplate = `${baseUrl}/export`;

    const queryParams = {
      ['includeArchived']: includeArchived,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ExportPreviewListV1>;
  }

  /**
   * @summary Update the details of an export
   * @param {string} id - ID of the export to update
  */
  public updateExport(
    body: models.ExportItemsV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/export/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/export/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ExportItemsOutputV1>;
  }

}


export const sqExportApi = new sqExportApiClass();

export type sqExportApiEndpoints = {
  'archiveExport': {
    method: 'delete';
    path: '/export/${encodeURIComponent(String(id))}';
    response: models.ExportItemsOutputV1;
  };
  'archiveExportsOlderThan': {
    method: 'delete';
    path: '/export/cleanup';
    response: models.StatusMessageBase;
  };
  'createExport': {
    method: 'post';
    path: '/export';
    response: Blob;
  };
  'getExport': {
    method: 'get';
    path: '/export/${encodeURIComponent(String(id))}';
    response: models.ExportItemsOutputV1;
  };
  'getExports': {
    method: 'get';
    path: '/export';
    response: models.ExportPreviewListV1;
  };
  'updateExport': {
    method: 'post';
    path: '/export/${encodeURIComponent(String(id))}';
    response: models.ExportItemsOutputV1;
  };
};

type ApiArchiveExportResponse = models.ExportItemsOutputV1;
type ApiarchiveExportMutationParams = Parameters<typeof sqExportApi.archiveExport> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqExportApi.archiveExport>;

export function useApiArchiveExportMutation(
  options?: Omit<UseMutationOptions<ApiArchiveExportResponse, AxiosError<SeeqErrorData>,
    ApiarchiveExportMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveExportResponse, AxiosError<SeeqErrorData>,
  ApiarchiveExportMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveExportMutationParams) =>
      sqExportApi.archiveExport(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveExportsOlderThanResponse = models.StatusMessageBase;
type ApiarchiveExportsOlderThanMutationParams = Parameters<typeof sqExportApi.archiveExportsOlderThan> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqExportApi.archiveExportsOlderThan>;

export function useApiArchiveExportsOlderThanMutation(
  options?: Omit<UseMutationOptions<ApiArchiveExportsOlderThanResponse, AxiosError<SeeqErrorData>,
    ApiarchiveExportsOlderThanMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveExportsOlderThanResponse, AxiosError<SeeqErrorData>,
  ApiarchiveExportsOlderThanMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveExportsOlderThanMutationParams) =>
      sqExportApi.archiveExportsOlderThan(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateExportResponse = Blob;
type ApicreateExportMutationParams = Parameters<typeof sqExportApi.createExport> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqExportApi.createExport>;
type ApicreateExportMutationVariables = models.ExportItemsV1;

export function useApiCreateExportMutation(
  options?: Omit<UseMutationOptions<ApiCreateExportResponse, AxiosError<SeeqErrorData>,
    ApicreateExportMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateExportResponse, AxiosError<SeeqErrorData>,
  ApicreateExportMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateExportMutationVariables) =>
      sqExportApi.createExport(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetExportResponse = models.ExportItemsOutputV1;
export function GetExportQueryKey(
  params: Parameters<typeof sqExportApi.getExport>[0],
) {
  return ['sqExportApi', 'getExport', params] as const;
}

export function useApiGetExportQuery(
  params: Parameters<typeof sqExportApi.getExport>[0],
  options?: Omit<UseQueryOptions<ApiGetExportResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetExportResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetExportQueryKey(params),
    queryFn: () =>
      sqExportApi.getExport(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetExportsResponse = models.ExportPreviewListV1;
export function GetExportsQueryKey(
  params: Parameters<typeof sqExportApi.getExports>[0],
) {
  return ['sqExportApi', 'getExports', params] as const;
}

export function useApiGetExportsQuery(
  params: Parameters<typeof sqExportApi.getExports>[0],
  options?: Omit<UseQueryOptions<ApiGetExportsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetExportsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetExportsQueryKey(params),
    queryFn: () =>
      sqExportApi.getExports(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateExportResponse = models.ExportItemsOutputV1;
type ApiupdateExportMutationParams = Parameters<typeof sqExportApi.updateExport> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqExportApi.updateExport>;

export function useApiUpdateExportMutation(
  options?: Omit<UseMutationOptions<ApiUpdateExportResponse, AxiosError<SeeqErrorData>,
    ApiupdateExportMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateExportResponse, AxiosError<SeeqErrorData>,
  ApiupdateExportMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateExportMutationParams) =>
      sqExportApi.updateExport(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
